import { getPWAMainMenuAction, getPWASubMenuAction } from "../../API/action";
import fetchMenuData from "./fetchMenuData";

export const fetchMainMenu = fetchMenuData({
  isFetchedKey: "isMenuFetched",
  apiCall: getPWAMainMenuAction,
  successType: "SET_MENU_ITEMS"
});

export const fetchSubMenu = fetchMenuData({
  isFetchedKey: "isSubMenuFetched",
  apiCall: getPWASubMenuAction,
  successType: "SET_INNER_MENU_ITEMS"
});